// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-color[data-v-aa2ac188]{color:var(--lms-tenant)}.page-header[data-v-aa2ac188]{font-style:normal;font-weight:700;font-size:28px;line-height:42px;color:var(--lms-tenant)!important;letter-spacing:.11px}.page-sub[data-v-aa2ac188]{font-size:16px;line-height:30px;letter-spacing:.11px;color:var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
